import dynamic from 'next/dynamic';
import { Suspense } from 'react';

import type { UnavailableMediaAction } from '~context/mediaGallery/types';

export const Content = dynamic(() =>
	import('./dynamicContent').then((mod) => mod.SingleMediaPage)
);

type Props = {
	mediaId: string;
	updatePageTitle?: boolean;
	unavailableMediaAction?: UnavailableMediaAction;
};

export const SingleMediaPageDynamic = (props: Props) => {
	return (
		<Suspense>
			<Content {...props} />
		</Suspense>
	);
};
